const empty = ''

export default [
  ['=', '+', '%', '*', '[', ']', '{', '}', '<', '>'],
  ['@', ':', '', '_', '-', '#', '(', ')', '/', '\\'],
  ['.', ',', '?', '!', `'${empty}`, '"', '^'],
]
